import React from 'react';
import { DataProvider } from 'src/contexts/data';
import { useAuth } from '../contexts/auth';

import AppRoutes from './app.routes';
import AuthRoutes from './auth.routes';
import MechanicalRoutes from './mechanical.routes';

const Routes: React.FC = () => {
    const { signed, userLevel } = useAuth();

    return signed && userLevel === 0 ? 
        <DataProvider>
            <AppRoutes />
        </DataProvider> :
        signed && userLevel === 2 ?
        <DataProvider>
            <MechanicalRoutes />
        </DataProvider>
        :
        <AuthRoutes />;
}

export default Routes;